import LazyLoad from './lazyload.min.js';
var lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy',
});